import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import { dashboardUserInfoKeys } from "./useDashboardUserInfo";

interface LanguagePromptAnswer {
  modelType?: string | null;
}

/**
 * Answers the language question. The server maps the answer onto a model type.
 * Whether to ask is read from provider settings (`language_model_popup`).
 */
export function useAnswerLanguagePrompt() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (conductsNonEnglishSessions: boolean) =>
      (await api.put("/dashboard/language-prompt", {
        conductsNonEnglishSessions,
      })) as LanguagePromptAnswer,
    onSuccess: () => {
      // The Settings model-type selector reads the same value.
      queryClient.invalidateQueries({ queryKey: dashboardUserInfoKeys.all });
    },
  });
}

export default useAnswerLanguagePrompt;
